

// Lazy-loaded components for code splitting
const DocumentCategoryList = () => import(/* webpackChunkName: "document-category" */ "./pages/ListPage.vue");
const DocumentCategoryDetail = () => import(/* webpackChunkName: "document-category" */ "./pages/FormPage.vue");
const DocumentCategoryIndex = () => import(/* webpackChunkName: "document-category" */ "./pages/IndexPage.vue");
export default [
  {
    path: "/document_category",
    component: DocumentCategoryIndex,
    redirect: "/document_category/list",
    name: "document_category",
    children: [
      {
        path: "list",
        component: DocumentCategoryList,
        name: "document_category.list",
      },
      {
        path: "create",
        component: DocumentCategoryDetail,
        name: "document_category.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DocumentCategoryDetail,
        name: "document_category.edit",
        props: { create: false },
      },
    ],
  },
];
